import { render, staticRenderFns } from "./Pdpa.vue?vue&type=template&id=6cf1f9ba&scoped=true&"
import script from "./Pdpa.vue?vue&type=script&lang=js&"
export * from "./Pdpa.vue?vue&type=script&lang=js&"
import style0 from "./Pdpa.vue?vue&type=style&index=0&id=6cf1f9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf1f9ba",
  null
  
)

export default component.exports